import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { createSelector } from "@reduxjs/toolkit";
import { getOriginalHtmlFactory } from "@src/store/slices/experienceBuilder/common/selectors/getOriginalHtmlFactory";
import { getTextFromHTML } from "@src/store/slices/experienceBuilder/common/utils/html/getTextFromHTML";

export const getOriginalTextFactory = (mod: EmbeddedMod) =>
  createSelector(getOriginalHtmlFactory(mod), (html) => {
    return getTextFromHTML(html);
  });
